(function(){
  var done={};

  function saveData(){
    try{
      var c=navigator.connection;
      if(!c)return false;
      if(c.saveData)return true;
      if(/(^|\W)(slow-)?2g/.test(c.effectiveType||''))return true;
    }catch(e){}
    return false;
  }

  function prefetch(url){
    if(!url||done[url])return;
    done[url]=1;
    var l=document.createElement('link');
    l.rel='prefetch';l.as='document';l.href=url;
    document.head.appendChild(l);
  }

  function links(){return document.querySelectorAll('.et-color-switch__item[href]');}

  /* 2026-09-08. Cia buvo click klausytojas, kuris i sessionStorage
     ('etColorScroll') irasydavo, kurioje vietoje zmogus buvo, o kitas
     scenarijus naujame spalvos puslapyje ta vieta atkurdavo. Del to
     klientas nepamatydavo naujos spalvos pirmos nuotraukos.
     Ritos nurodymu isimta - spalvos puslapis atsidaro nuo virsaus. */
  function hookUp(){
    var a=links();
    for(var i=0;i<a.length;i++){
      var el=a[i];
      if(el.getAttribute('data-et-pf'))continue;
      el.setAttribute('data-et-pf','1');
      el.addEventListener('mouseenter',function(){warm(this.getAttribute('href'));});
      el.addEventListener('touchstart',function(){warm(this.getAttribute('href'));},{passive:true});
    }
  }

  /* Koks dydis pasirinktas dabar. Ta pati logika kaip custom.js
     currentSize() - jei ji ten keistusi, reiketu keisti ir cia. */
  function currentSize(){
    var sel=null;
    var all=document.querySelectorAll('.product-form__option-selector');
    for(var i=0;i<all.length;i++){
      var n=all[i].querySelector('.product-form__option-name');
      if(n&&/size/i.test(n.textContent)) sel=all[i];
    }
    if(!sel)return null;
    var active=sel.querySelector('.combo-box__option-item[aria-selected="true"]');
    if(active)return active.textContent.trim();
    var checked=sel.querySelector('.block-swatch__radio:checked, input[type="radio"]:checked');
    if(checked){
      var lbl=sel.querySelector('label[for="'+checked.id+'"]')||sel.querySelector('.block-swatch__item');
      var full=lbl?(lbl.getAttribute('data-et-full')||lbl.textContent.trim()):null;
      return full?full.split('·')[0].trim():null;
    }
    var native=sel.querySelector('select');
    return native&&native.selectedOptions[0]?native.selectedOptions[0].textContent.trim():null;
  }

  /* ------------------------------------------------------------------
     ELA TEILA 2026-09-07. KODEL SIS FAILAS PERDARYTAS.

     Anksciau cia buvo prefetch("/products/x"), o custom.js paspaudus
     spalva eina i "/products/x?variant=123" - narsyklei tai SKIRTINGI
     adresai, tad paruostas puslapis likdavo nepanaudotas. Prie to dar
     custom.js pries pat navigacija daro fetch("/products/x.js"), kad
     surastu ta pati dydi kitoje spalvoje - dar viena uzklausa paspaudimo
     kelyje.

     Dabar tas pats darbas atliekamas IS ANKSTO, puslapiui uzsikrovus:
       1) atsiunciam /products/x.js  -> custom.js ta pacia uzklausa paspaudus
                                        gaus is narsykles atminties
       2) randam varianta su tuo paciu dydziu
       3) prefetch'inam TIKRAJI adresa su ?variant=

     custom.js NEKEICIAMAS - jo logika teisinga, tik atliekama per velai.

     Riba if(window.innerWidth<1000)return NUIMTA - telefonas gauna ta pati
     ka desktopas. Duomenys valdomi: saveData() ir LIMIT 6.

     GRAZINIMAS: uzteks palikti tik prefetch(href) be varianto paieskos.
     ------------------------------------------------------------------ */
  var warmed={};
  function warm(href){
    if(!href)return;
    var base=href.split('?')[0];
    if(warmed[base])return;
    warmed[base]=1;
    var size=currentSize();
    fetch(base+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(p){
      var url=base;
      if(size&&p&&p.variants){
        var m=p.variants.filter(function(x){return x.available;}).find(function(x){return x.options.indexOf(size)!==-1;})
              ||p.variants.find(function(x){return x.options.indexOf(size)!==-1;});
        if(m)url=base+'?variant='+m.id;
      }
      prefetch(url);
    }).catch(function(){prefetch(base);});
  }

  function prefetchAll(){
    if(saveData())return;
    var a=links(), LIMIT=6, n=0;
    for(var i=0;i<a.length;i++){
      if(/is-current/.test(a[i].className))continue;
      if(n>=LIMIT)break;
      warm(a[i].getAttribute('href'));
      n++;
    }
  }

  /* Pasikeitus dydziui senas prefetch nebetinka - paruosiam is naujo. */
  function watchSize(){
    document.addEventListener('change', function(e){
      if(!e.target||!e.target.closest)return;
      if(!e.target.closest('.product-form__option-selector'))return;
      warmed={}; done={};
      setTimeout(prefetchAll,50);
    }, {passive:true});
  }

  function start(){
    hookUp();
    prefetchAll();
    watchSize();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  window.addEventListener('load',hookUp);
})();
